import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { PopUpDialogInformalService } from "../../services/confirms/popUpDialogInformal.service";
import { PopUpInformalType } from "../../components/ui-components/pop-ups/pop-up-informal/pop-up-informal.model";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import {
  DertAuthResponse,
  LanguageService,
  LoginService,
  SharedService,
} from "@dert-services";
import { catchError, lastValueFrom, of } from "rxjs";
import { VersionCheckService } from "../../services/version-check.service";

@Component({
  selector: "redirect",
  templateUrl: "./redirect.component.html",
  styleUrls: ["./redirect.component.scss"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class RedirectComponent {
  private spinner = inject(NgxSpinnerService);
  private translate = inject(TranslateService);
  private router = inject(Router);
  private popUpDialogInformalService = inject(PopUpDialogInformalService);
  private _http = inject(HttpClient);
  private loginService = inject(LoginService);
  private _sharedService = inject(SharedService);
  private _languageService = inject(LanguageService);
  private versionCheckService = inject(VersionCheckService);

  private _redirectUrl: string = `${environment.apiAddress}/api/dert/redirect`;

  // on init, read the URL parameters and redirect accordingly
  async ngOnInit() {
    if (await this.versionCheckService.reloadIfNewVersion()) {
      return;
    }

    this.spinner.show();
    const urlParams = new URLSearchParams(window.location.search);
    const encodedParam = urlParams.get("encoded");
    const countryCodeParam = urlParams.get("countryCode") || "cz";

    this._languageService.setLanguage(countryCodeParam, false);
    localStorage.setItem("countryCode", countryCodeParam);

    if (encodedParam) {
      const res = await lastValueFrom(
        this._http
          .get<DertAuthResponse>(this._redirectUrl, {
            params: { encoded: encodedParam, countryCode: countryCodeParam },
          })
          .pipe(
            catchError(() => {
              return of(null);
            }),
          ),
      );
      this.spinner.hide();

      if (res && res.jwtToken) {
        this.loginService.setAuthToken(res.jwtToken);
        this.loginService.loggedIn = true;

        if (this.loginService.roles().length) {
          await this.loadConfig();

          const redirectTo = `${res.action}?${res.queryParams}`;
          this.router.navigateByUrl(redirectTo).then(() => {});
        } else {
          await this.router.navigate(["/dashboard"]);
        }
      } else {
        this.loginService.logout();
      }

      this.spinner.hide();
    } else {
      this.spinner.hide();
      this.popUpDialogInformalService.confirm({
        title: this.translate.instant("webPos.RedirectErrorTitle"),
        message: this.translate.instant("webPos.RedirectErrorMessage"),
        type: PopUpInformalType.Error,
      });
    }
  }

  private async loadConfig(): Promise<void> {
    const configLoadSuccessfully = await this._sharedService.loadFEConfig();
  }
}
